import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const ArchivedBanner = styled(Flex)<FlexProps>`
	border: 1px solid ${({ theme }) => theme.v3.colors.orange[6]};
	border-radius: 8px;
`;
